import React from 'react';

import '../styles/admin.css';

import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import ZoomShell from './ZoomShell';

// ── Zoom-style console rollout gate ──────────────────────────────────────────
// Now enabled for ALL tenants and super admin. The sidebar (ZoomShell) is
// role-aware, so super admins keep every platform page. To roll back to the
// pilot, set ZOOM_SHELL_ALL = false (then only ZOOM_SHELL_TENANTS get it).
const ZOOM_SHELL_ALL = true;
const ZOOM_SHELL_TENANTS: number[] = [2];

type AdminShellProps = {
  user: any;
  onLogout: () => void;
  active: string;
  setActive: (page: string) => void;
  children: React.ReactNode;
};

function AdminShell({
  user,
  onLogout,
  active,
  setActive,
  children
}: AdminShellProps) {
  const useZoom = ZOOM_SHELL_ALL || ZOOM_SHELL_TENANTS.includes(Number(user?.tenant_id));

  if (useZoom) {
    return (
      <ZoomShell
        user={user}
        onLogout={onLogout}
        active={active}
        setActive={setActive}
      >
        {children}
      </ZoomShell>
    );
  }

  return (
    <div className="admin-shell">
      <Sidebar
        active={active}
        setActive={setActive}
        user={user}
      />

      <div className="main-area">
        <Topbar
          title={active}
          user={user}
          onLogout={onLogout}
        />

        <div className="page-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export default AdminShell;
